<template>
  <!-- <div v-if="!has_perm('view_service_package')">
    <div class="col-md-12">
      <h1 style="text-align: center; color: red;">
        {{ $t("common.not_permission") }} !
      </h1>
    </div>
  </div> -->
  <div v-if="has_perm('view_service_package') || GET_ACCOUNT_DATA.id == 1">
    <div class="box box-primary">
      <div class="box-header">
        <h3 class="box-title" style="text-transform: capitalize;">
          Gói Dịch Vụ Mẫu
        </h3>
      </div>
      <div class="box-body">
        <div class="row">
          <div class="col-md-12" style="text-align: right;">
            <button
              v-if="has_perm('create_service_package')"
              class="btn btn-info btn-sm extra-tools"
              @click="onOpenAddInput"
            >
              <i class="glyphicon glyphicon-plus"></i> Add
            </button>
          </div>
          <div class="col-md-12">
            <b-table
              :items="pkg_tmpl_items"
              :fields="pkg_tmpl_fields"
              class="mt-3 package-table"
              outlined
            >
              <template #head()="scope">
                <div>{{ $t(scope.label) }}</div>
              </template>
              <template slot="room_rate" slot-scope="row">
                {{ row.item.room_rate }} /
                {{
                  $t(
                    `service.package.payment_duration_factor_value.${
                      row.item.payment_duration_factor
                    }`
                  )
                }}
              </template>
              <template slot="actions" slot-scope="row">
                <div class="btn-group">
                  <button
                    type="button"
                    class="btn btn-danger dropdown-toggle"
                    data-toggle="dropdown"
                    aria-expanded="true"
                  >
                    <i class="fa fa-fw fa-ellipsis-h"></i>
                  </button>
                  <ul
                    class="dropdown-menu"
                    style="min-width: 50px;height: 80px;"
                  >
                    <li>
                      <button
                        class="btn btn-primary btn-sm"
                        style="margin-left: 6px;"
                        @click="onOpenEditInput(row)"
                      >
                        <i class="glyphicon glyphicon-edit"></i>
                      </button>
                    </li>
                    <li>
                      <button
                        class="btn btn-danger btn-sm"
                        style="margin-left: 6px;"
                        @click="onOpenDeletePakageTemplateConfirm(row)"
                      >
                        <i class="glyphicon glyphicon-trash"></i>
                      </button>
                    </li>
                  </ul>
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="box-footer">
        <div class="row">
          <div class="col-md-12">
            <paginator :item="paginatorItem" @onpaginate="onPagination" />
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Confirm Delete -->
    <div class="modal fade" :ref="`modal-pkg-tmpl`">
      <div class="modal-dialog">
        <confirm :id="pkg_tmpl_data.id" @confirm="onDeleteConfirm" />
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// import RegisterVehicleInputView from './RegisterVehicleInputView'
// import moment from "moment"
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Confirm from "@/components/Confirm.vue";
import Paginator from "@/components/Paginator.vue";
// import Loading from "vue-loading-overlay"
import utils from '@/lib/utils';

export default {
  name: "PackageTemplateView",
  data() {
    return {
      pkg_tmpl_data: {
        id: 0
      },
      pkg_tmpl_items: [],
      pkg_tmpl_fields: [
        {
          key: "nonumber",
          label: "common.nonumber",
          sortable: false,
          class: "text-center"
        },
        { key: "pkg_name", label: "service.package.pkg_name", sortable: false },
        {
          key: "pkg_apt_bedrooms",
          label: "service.package.pkg_apt_bedrooms",
          sortable: false,
          class: "text-center"
        },
        {
          key: "room_rate",
          label: "service.package.pkg_room_rate",
          sortable: false,
          class: "text-right"
        },
        {
          key: "other_details",
          label: "service.package.pkg_other_details",
          sortable: false,
          class: "package-table-td"
        },
        { key: "pkg_type", label: "service.package.pkg_type", sortable: false },
        { key: "actions", label: "common.action", sortable: false }
      ],
      paginatorItem: {
        commit_function: "PACKAGE_TEMPLATE_LIST"
      }
    };
  },
  watch: {
    package_templates: function() {
      let pkg_tmpl_items = [];
      this.package_templates.forEach((v, i) => {
        let id = v.id;
        let nonumber =
          i + 1 + (this.PAGINATION.page - 1) * this.PAGINATION.size;
        let pkg_name = v.pkg_name;
        let pkg_apt_bedrooms = v.pkg_apt_bedrooms;
        let room_rate = 0;
        for (let j = 0; j < v.package_elements.length; j++) {
          let element = v.package_elements[j];
          if (element.service_details.service_type === 9) {
            room_rate = element.service_details.price;
            break;
          }
        }
        let pkg_other_details = v.pkg_other_details;
        let pkg_type = this.getPackageTypeName(v.pkg_type);
        let payment_duration_factor = v.payment_duration_factor;
        let item = {
          id: id,
          nonumber: nonumber,
          pkg_name: pkg_name,
          pkg_apt_bedrooms: pkg_apt_bedrooms,
          room_rate: this.formatNumber(room_rate),
          other_details: pkg_other_details,
          pkg_type: pkg_type,
          payment_duration_factor: payment_duration_factor
        };
        pkg_tmpl_items.push(item);
      });
      this.pkg_tmpl_items = pkg_tmpl_items;
    }
  },
  computed: {
    ...mapGetters("packageModule", {
      package_templates: "PACKAGE_TEMPLATE_LIST"
    }),
    ...mapGetters([
      "GET_SNACK_BAR",
      "PAGINATION",
      "PAGINATOR",
      "PAGE_ARROW",
      "GET_ACCOUNT_DATA"
    ])
  },
  methods: {
    ...mapActions("packageModule", [
      "GET_PACKAGE_TEMPLATE_LIST",
      "DELETE_PACKAGE_TEMPLATE"
    ]),
    has_perm: function(perm) {
      return utils.has_perm(this.GET_ACCOUNT_DATA, perm);
    },
    formatNumber: function(n) {
      return utils.formatNumber(n);
    },
    getPackageTypeName: function (type) {
      return this.$t(utils.getPackageTypeName(type))
    },
    onOpenAddInput: function() {
      this.$router.push({
        name: "PackageDetails",
        params: {
          id: 0
        }
      });
    },
    onOpenEditInput: function(row) {
      let id = row.item.id;
      this.$router.push({
        name: "PackageDetails",
        params: {
          id: id
        }
      });
    },
    onOpenDeletePakageTemplateConfirm: function(row) {
      this.pkg_tmpl_data.id = row.item.id;
      this.onToggleDeleteConfirm();
    },
    onToggleDeleteConfirm: function(action = "show") {
      $(this.$refs[`modal-pkg-tmpl`]).modal(action);
    },
    onDeleteConfirm: function(id) {
      const payload = {
        id: id
      };
      this.DELETE_PACKAGE_TEMPLATE(payload).then(
        function() {
          this.onToggleDeleteConfirm("hide");
          this.GET_PACKAGE_TEMPLATE_LIST();
        }.bind(this)
      );
    },
    getList: function(data) {
      const payload = data || {
        params: {
          page: 1
        }
      };
      this.isLoading = true;
      this.GET_PACKAGE_TEMPLATE_LIST(payload).then(
        function() {
          this.isLoading = false;
        }.bind(this)
      );
    },
    onPagination: function(data) {
      this.getList(data);
    }
  },
  mounted() {
    this.getList();
  },
  components: {
    "lte-core-alert": LTECoreAlert,
    confirm: Confirm,
    paginator: Paginator
    // "loading": Loading
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.package-table {
  table-layout: fixed;
}

.package-table-td {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/views/Service/PackageTemplateView.vue